/* Environment Variables */
export const apiURL = process.env.REACT_APP_API_HOST;
